import {FormControl, FormField, Option} from 'platform/components';
import {match} from 'ts-pattern';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {TemplateMoneyCurrencies} from '../utils/resolveTemplateMoneyCurrencies';
import {VehicleFinancingTemplateFormValues} from '../vehicleFinancingTemplateFormSchema';
import {VehicleFinancingTemplateSegmentScopeFields} from './VehicleFinancingTemplateSegmentScopeFields';

interface VehicleFinancingTemplateScopeFieldsProps extends TestIdProps {
  control: FormControl<VehicleFinancingTemplateFormValues>;
  formApi: UseFormReturn<VehicleFinancingTemplateFormValues>;
  mode: VehicleFinancingTemplateFormValues['scope']['mode'];
  branchOptions: Option[];
  moneyCurrencies: TemplateMoneyCurrencies;
}

export function VehicleFinancingTemplateScopeFields(
  props: VehicleFinancingTemplateScopeFieldsProps
) {
  return match(props.mode)
    .with('ALL_VEHICLES', () => null)
    .with('BRANCH', () => (
      <FormField
        control={props.control}
        name="scope.branchIds"
        type="multiChoice"
        isRequired
        label={i18n.t('entity.branch.labels.branch')}
        options={props.branchOptions}
        placeholder={i18n.t('general.labels.selectOption')}
        data-testid={suffixTestId('scope-branchIds', props)}
      />
    ))
    .with('SEGMENT', () => (
      <VehicleFinancingTemplateSegmentScopeFields
        control={props.control}
        formApi={props.formApi}
        moneyCurrencies={props.moneyCurrencies}
        data-testid={props['data-testid']}
      />
    ))
    .exhaustive();
}
